<template>
  <v-dialog max-width="600px" :value="visible" @input="$emit('update:visible', $event)" persistent>
    <v-card dark v-if="editableItem">
      <v-card-title class="font-weight-bold contractSettings__dialog-title justify-center mb-5">
        {{ editableItem.title }}
      </v-card-title>
      <v-card-text>
        <v-row no-gutters class="px-5">
          <v-col cols="12">
            <v-text-field
              v-model="editableItem.title"
              label="Bezeichnung"
              :disabled="isExistingItem"
              hint="Der Titel kann nach dem Erstellen nur über die 'Umbenennen'-Funktion geändert werden."
              persistent-hint></v-text-field>
            <v-textarea v-model="editableItem.description" label="Beschreibung" counter="150" class="mt-4"></v-textarea>
            <v-switch v-model="editableItem.flexActive" label="Flexible Laufzeit?"></v-switch>
            <v-select
              label="Studios"
              multiple
              v-model="editableItem.studios"
              :items="studios"
              item-text="name"
              item-value="_id"
              @change="changeStudios"></v-select>
          </v-col>
        </v-row>

        <v-expansion-panels class="mb-5" v-model="panel" multiple>
          <v-expansion-panel v-for="(settings, studioId) in editableItem.studioSettings" :key="studioId">
            <v-expansion-panel-header>{{ getStudioName(studioId) }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <template v-if="!editableItem.flexActive">
                <v-card-subtitle class="px-0">Laufzeiten und Preise</v-card-subtitle>
                <div v-for="(duration, i) in settings.durations" :key="i + '-duration'" class="mb-4 pa-3 grey darken-3 rounded">
                  <v-row dense>
                    <v-col cols="4"><v-text-field v-model.number="duration.years" type="number" label="Jahre"></v-text-field></v-col>
                    <v-col cols="4"><v-text-field v-model.number="duration.months" type="number" label="Monate"></v-text-field></v-col>
                    <v-col cols="4"><v-text-field v-model.number="duration.days" type="number" label="Tage"></v-text-field></v-col>
                    <v-col cols="6"><v-text-field v-model.number="duration.price" type="number" label="Preis"></v-text-field></v-col>
                    <v-col cols="6"><v-text-field v-model.number="duration.signUpFee" type="number" label="Aktivierungs-Tarif"></v-text-field></v-col>

                    <v-col cols="12"><v-switch v-model="duration.saleActive" label="Aktion aktiv"></v-switch></v-col>
                    <template v-if="duration.saleActive">
                      <v-col cols="6"><v-text-field v-model.number="duration.salePrice" type="number" label="Aktionspreis"></v-text-field></v-col>
                      <v-col cols="6"><v-switch v-model="duration.saleGiftSignUpFee" label="Aktivierungs-Tarif schenken"></v-switch></v-col>
                      <v-col cols="12"><v-switch v-model="duration.saleTimeLimit" label="Zeitlich begrenzt"></v-switch></v-col>
                      <v-col v-if="duration.saleTimeLimit" cols="6"
                        ><v-text-field v-model="duration.saleFrom" type="date" label="Aktion von"></v-text-field
                      ></v-col>
                      <v-col v-if="duration.saleTimeLimit" cols="6"
                        ><v-text-field v-model="duration.saleTill" type="date" label="Aktion bis"></v-text-field
                      ></v-col>
                    </template>
                  </v-row>
                  <v-btn small color="error" @click="removeDuration(studioId, i)">Laufzeit Entfernen</v-btn>
                </div>
                <v-btn color="primary" @click="addDuration(studioId)" class="mt-4">Laufzeit Hinzufügen</v-btn>
              </template>

              <template v-else>
                <v-card-subtitle class="px-0">Preise pro {{ editableItem.flexSelection === "perMonth" ? "Monat" : "Tag" }}</v-card-subtitle>
                <v-row>
                  <v-col cols="6"
                    ><v-text-field v-model.number="settings.flex.prices[editableItem.flexSelection].price" type="number" label="Preis"></v-text-field
                  ></v-col>
                  <v-col cols="6"
                    ><v-text-field
                      v-model.number="settings.flex.prices[editableItem.flexSelection].signUpFee"
                      type="number"
                      label="Aktivierungs-Tarif"></v-text-field
                  ></v-col>
                </v-row>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions class="contractSettings__dialog-actions">
        <v-btn class="white--text" text @click="$emit('update:visible', false)">Abbrechen</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="white--text" text @click="$emit('save', { item: editableItem, type: 'membership' })">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "MembershipEditor",
  props: ["visible", "item", "studios"],
  data() {
    return {
      editableItem: null,
      panel: [],
    }
  },
  computed: {
    isExistingItem() {
      return this.item && this.item.title !== "Neu"
    },
  },
  watch: {
    item: {
      handler(newItem) {
        this.editableItem = newItem ? JSON.parse(JSON.stringify(newItem)) : null
      },
      immediate: true,
    },
  },
  methods: {
    getStudioName(studioId) {
      const studio = this.studios.find((s) => s._id === studioId)
      return studio ? studio.name : "Unbekanntes Studio"
    },
    changeStudios() {
      const newSettings = {}
      this.editableItem.studios.forEach((studioId) => {
        newSettings[studioId] = this.editableItem.studioSettings[studioId] || {
          flex: { prices: { perDay: {}, perMonth: {} } },
          durations: [],
        }
      })
      this.editableItem.studioSettings = newSettings
    },
    addDuration(studioId) {
      this.editableItem.studioSettings[studioId].durations.push({
        years: 0,
        months: 0,
        days: 0,
        price: 0,
        signUpFee: 0,
        saleActive: false,
        salePrice: 0,
        saleGiftSignUpFee: false,
        saleTimeLimit: false,
        saleFrom: null,
        saleTill: null,
      })
    },
    removeDuration(studioId, index) {
      this.editableItem.studioSettings[studioId].durations.splice(index, 1)
    },
  },
}
</script>
